export default "__VITE_ASSET__c5d155fe__"